<!-- <p>edit-asset-settings works!</p> -->
<app-dialog-header headerIcon="sensors" headerText="Asset Datapoints"
	(onCloseClick)="onCancelClick()"></app-dialog-header>
<div style="padding: 1em;">
	<table style="width: 500px;">
		<colgroup>
			<col width="30px">
			<col width="100%">
		</colgroup>
		<tr>
			<th><mat-label>Name:</mat-label></th>
			<td><mat-label>{{AssetItem.Name}}</mat-label></td>
		</tr>
		<tr>
			<th><mat-label>Description:</mat-label></th>
			<td><mat-label>{{AssetItem.Description}}</mat-label></td>
		</tr>
		<tr>
			<td colspan="2">
				<mat-toolbar class="dataPointToolbar" style="margin-top: 0.5em;background-color: transparent;">
					<span class="toolbar-spacer"></span>
					<span style="margin-right: 1em;">
						<span *ngIf="dataPoints">{{dataPoints.length}}</span>
						<span *ngIf="!dataPoints">0</span>
						<span>&nbsp;Data Points</span>
					</span>
					<mat-icon *ngIf="isAdmin" matTooltip="Add New Data Point"
						(click)="addDatapoint()">add_box</mat-icon>
				</mat-toolbar>
			</td>
		</tr>
		<tr>
			<td colspan="2">
				<ng-container *ngIf="dataPoints then assetDatapoints else noDatapoints"></ng-container>
			</td>
		</tr>
	</table>
</div>
<form [formGroup]="dialogForm">
	<div mat-dialog-actions>
		<button mat-button [mat-dialog-close]="dialogForm.value" [disabled]="dialogForm.invalid">Ok</button>
		<button mat-button (click)="onCancelClick()" cdkFocusInitial>Cancel</button>
	</div>
</form>

<ng-template #noDatapoints>
	<!-- <mat-label style="font-weight: bold;">No Data Points</mat-label> -->
</ng-template>
<ng-template #assetDatapoints>
	<!-- <mat-label style="font-weight: bold;margin: 0px;padding: 0px;">Data Points</mat-label> -->
	<div class="listview-container">
		<ejs-listview id='listview-scrolling' #listviewInstance [dataSource]='dataPoints' cssClass='e-list-template'>
			<ng-template #template let-dataSource>
				<div class="ejs-listview-item listview-datapoint">
					<img class="image" src="{{dataSource.ImageURL}}"
						onerror="this.src='https://stmgwebappstorage.blob.core.windows.net/prismpdm/assets/noimage.png'"
						(click)="viewImage(dataSource.ImageURL)" [attr.x-contenttype]="'image/png'" />
					<div class="detail">
						<div id="id-name" class="name">{{ dataSource.SensorName}}</div>
						<div id="id-description" class="description">{{dataSource.PVName }} ({{dataSource.SI }})
						</div>
					</div>
					<div class="me-auto"></div>
					<div class="edit">
						<div class="toggles">
							<div class="ShowOnChart">
								<span>Show On Chart</span>
								<mat-slide-toggle *ngIf="isAdmin" labelPosition="before"
									[(ngModel)]="dataSource.ShowOnChart" color="primary"
									(change)="patchAssetDataPoint(dataSource, $event, DataPointToggleOptions.ShowOnChart)"/>
							</div>
							<!-- *ngIf="checkFeature(AccountFeatures.Tile_Customisation)" -->
							<div class="ShowOnChart">
								<span>Show On Tile</span>
								<mat-slide-toggle *ngIf="isAdmin" labelPosition="before"
									[(ngModel)]="dataSource.ShowOnTile" color="primary"
									(change)="patchAssetDataPoint(dataSource, $event, DataPointToggleOptions.ShowOnTile)"/>
							</div>
							<div class="ShowOnChart" *ngIf="dataSource.IsCumulative">
								<span>Display Delta Value</span>
								<mat-slide-toggle *ngIf="isAdmin" labelPosition="before"
									[(ngModel)]="dataSource.ShowDeltaValue" color="primary"
									(change)="patchAssetDataPoint(dataSource, $event, DataPointToggleOptions.DisplayDeltaValue)"/>
							</div>
						</div>
						<span *ngIf="isAdmin" class="app-icon app-icon--delete" style="margin-right: 5px;"
							matTooltip="Remove Datapoint" matTooltipPosition="above">
							<mat-icon style="color: var(--color-red);" (click)="deleteDataPoint(dataSource)" />
						</span>
					</div>
				</div>

				<!--
				<div class="edit">
					<span class="alignRow">
						<mat-slide-toggle color="primary" [checked]="dataSource.ShowOnChart"
							(change)="patchAssetDataPoint(dataSource, $event)"></mat-slide-toggle>
						<mat-label>Show On Chart </mat-label>
					</span>
					<span class="no-wrap-tooltip app-icon app-icon--delete" style="display: flex;margin-right: 5px;"
						matTooltip="Remove Datapoint" matTooltipPosition="above">
						<mat-icon style="color: var(--color-red);" (click)="deleteDataPoint(dataSource)" />
					</span>
				</div> -->

			</ng-template>
		</ejs-listview>
	</div>
</ng-template>